module.exports = __webpack_public_path__ + "img/footer-xxl.66b4ea9c.png";